"use client"

import * as React from "react"
import * as SwitchPrimitive from "@radix-ui/react-switch"
import { cn } from "@/src/lib/utils"

function Switch({
  className,
  ...props
}: React.ComponentProps<typeof SwitchPrimitive.Root>) {
  return (
    <SwitchPrimitive.Root
      {...props}
      className={cn(
        // Track: 40x16
        "relative inline-flex h-4 w-10 shrink-0 items-center rounded-full transition-colors",
        // off-state: gray track
        "data-[state=unchecked]:bg-[#D8D8D8]",
        // on-state: blue→purple gradient + subtle purple outline (like reference)
        "data-[state=checked]:bg-gradient-to-r data-[state=checked]:from-blue-600 data-[state=checked]:to-purple-600",
        "data-[state=checked]:ring-1 data-[state=checked]:ring-inset data-[state=checked]:ring-purple-500/60",
        "focus-visible:outline-none",
        className
      )}
    >
      <SwitchPrimitive.Thumb
        className={cn(
          // Thumb: 26x14, centered vertically with 1px padding inside 16px track
          "pointer-events-none absolute left-[1px] top-1/2 -translate-y-1/2",
          "h-[14px] w-[26px] rounded-full",
          "bg-white shadow-sm",
          "box-border transition-transform",
          // Move to the right with symmetric 1px padding:
          // 40(track) - 26(thumb) - 1(left) - 1(right) = 12px
          "data-[state=checked]:translate-x-[12px]"
        )}
      />
    </SwitchPrimitive.Root>
  )
}

export { Switch }
